// extracted by mini-css-extract-plugin
export default {"card":"DeviceCard_card__xOrQm","header":"DeviceCard_header__SCHYL"};